export default "__VITE_ASSET__DCxBtF9t__"